import { useTranslation } from 'react-i18next';
import type { components } from '@/api/qraft/schema';
import { HelperInfoBlock } from './HelperInfoBlock';
import { IntroHeading } from './StudyHelperRequestModal.styles';

type StudyHelperBoardItem = components['schemas']['StudyHelperBoardItem'];

interface AdoptModalBodyProps {
  requestedHelper: StudyHelperBoardItem;
}

export function AdoptModalBody({ requestedHelper }: AdoptModalBodyProps) {
  const { t } = useTranslation();

  return (
    <>
      <IntroHeading>{t('wbs.request-to-be-adopted-by-this')}</IntroHeading>
      <HelperInfoBlock
        label={t('lessons.requested-study-helper-information')}
        helper={requestedHelper}
      />
    </>
  );
}
